var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-server-table',{staticClass:"table-borderless text-nowrap",attrs:{"columns":_vm.columns,"options":_vm.dtOptions},on:{"row-click":_vm.select}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b6cd616","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/_eng/globals/dDataTable.vue
// module id = 1573
// module chunks = 168 169